<template>
  <div>
    <com-dialog :visible.sync="visible" width="50%" title="审核">
      <el-descriptions title="提现信息" :column="1">
        <el-descriptions-item label="提现方式">{{
          form.type === '1' ? '微信' : '银行卡'
        }}</el-descriptions-item>
        <el-descriptions-item label="提现金额">{{ form.sum }}</el-descriptions-item>
        <template v-if="form.type === '1'">
          <el-descriptions-item label="微信账号">暂未开放</el-descriptions-item>
        </template>
        <template v-else>
          <el-descriptions-item label="银行卡号" v-if="form.bankcard.cardNumber">{{
            form.bankcard.cardNumber || ''
          }}</el-descriptions-item>
          <el-descriptions-item label="开户网点" v-if="form.bankcard.bankBranch">{{
            form.bankcard.bankBranch || ''
          }}</el-descriptions-item>
        </template>
        <el-descriptions-item label="收款人姓名">{{ form.realName }}</el-descriptions-item>
      </el-descriptions>
      <div class="mt-15px">
        <el-descriptions title="审核结果" :column="1">
          <el-descriptions-item label="审核结果">
            <div class="flex items-center">
              <el-radio :disabled="type === 'detail'" v-model="form.status" label="2"
                >通过</el-radio
              >
              <el-radio :disabled="type === 'detail'" v-model="form.status" label="3"
                >拒绝</el-radio
              >
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="流水号" v-if="form.status === '2'">
            <el-input
              placeholder=""
              :disabled="type === 'detail'"
              v-model="form.transactionId"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="打款凭证" v-if="form.status === '2'">
            <com-upload
              :originData="form.payProof"
              @postImage="success"
              @deleteImageUrl="deleteImg"
              :disabled="type === 'detail'"
              v-if="type !== 'detail'"
            ></com-upload>
            <img
              v-else
              @click="$store.commit('SHOW_IMAGE_WALL', form.payProof || item)"
              :src="form.payProof | filterImage"
              class="show_image"
            />
            <!-- <img style="width: 200px; height: 100px" :src="form.payProof | filterImage" v-else /> -->
          </el-descriptions-item>
          <el-descriptions-item label="拒绝原因" v-if="form.status === '3'">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="form.remark"
              :disabled="type === 'detail'"
            ></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="flex items-center justify-end">
        <el-button type="" @click="close">取消</el-button>
        <el-button type="primary" @click="submit" :disabled="type === 'detail'">确认</el-button>
      </div>
      <com-checked-pwd ref="checkPwd" @confirm="handleConfirm"></com-checked-pwd>
    </com-dialog>
  </div>
</template>

<script>
import { auditApi } from '@/api/finance'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      form: {},
      type: null
    }
  },
  methods: {
    baseParams() {
      const params = {
        status: ''
      }
      return params
    },
    open(opt) {
      const { row, type } = opt
      this.form = utils.deepCopy(row)
      this.type = type
      console.log('form :>> ', this.type, this.form)
      this.visible = true
    },
    close() {
      this.visible = false
    },
    success(url) {
      this.form.payProof = url
    },
    deleteImg() {
      this.form.payProof = ''
    },
    submit() {
      if (this.form.status === '2') {
        if (!this.form.transactionId || !this.form.payProof) {
          this.$message.error('请填写完整信息')
          return
        }
      }
      if (this.form.status === '3') {
        if (!this.form.remark) {
          this.$message.error('请填写完整信息')
          return
        }
      }
      console.log('this.type :>> ', this.type)
      if (this.type === 'detail') {
        this.close()
        return
      }

      this.$refs.checkPwd.open()
    },
    handleConfirm(val) {
      const params = { ...this.form, auditPassword: val }
      auditApi(params).then((res) => {
        if (res.status === 200) {
          this.$message.success('操作成功')
          this.$emit('success')
          this.close()
        }
      })
    }
  },
  created() {
    // this.open()
  }
}
</script>
<style lang="scss">
.show_image {
  object-fit: contain;
  width: 150px;
  height: 150px;
}
</style>
